<template>
  <div class="bg bg24">
    <div class="class--con">
      <class-but @forward="forward"/>
      <div class="video">
        <video controls
               :src="videoUrl"
        >
          您的浏览器不支持Video标签
        </video>
      </div>
    </div>
  </div>
</template>

<script>
import ClassBut from "@/views/conference/ConferenceItem/classBut.vue";
import service from "@/utils/axios";


export default {
  name: "videoPresentation1",
  components: {ClassBut},
  data() {
    return {
      videoUrl:null,
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      let r = await service.get(`/dwart/an_teaching/hbk/v1/getAdvVideo?classId=${this.$route.query.classId}&type=2`);
      if ( r.url ) {
        this.videoUrl = r.url;
      }else {
        this.$router.replace({
          name: 'semesterHighlights',
          query: this.$route.query,
        })
      }
    },
    forward() {
      this.$router.push({
        name: 'semesterHighlights',
        query: this.$route.query,
      })
    },
  }
}
</script>
<style lang="less" scoped>
@import "../ConferenceItem/reportClass.less";

.video {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  video {
    width: 1349px;
    height: 778px;
    border: 20px solid #ffe16c;
    border-radius: 20px;
  }
}
</style>
